import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo-centrao.png';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);

    try {
      await login(username, senha);
      navigate('/ti/dashboard');
    } catch (err) {
      setErro(err.response?.data?.message || err.response?.data?.error || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'radial-gradient(circle at 30% 20%, #11343C 0%, #0A1518 45%, #04080A 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ width: '100%', maxWidth: 420, padding: '0 16px' }}>
        <div
          className="card p-4 p-md-5"
          style={{
            background: '#15252B',
            color: '#E4ECEF',
            border: '1px solid #243B43',
            borderRadius: 20,
            boxShadow: '0 24px 60px rgba(0,0,0,0.55), 0 0 0 1px rgba(42,138,156,0.08)',
          }}
        >
          <div className="text-center mb-4">
            <img
              src={logo}
              alt="Centrao Materiais de Construcao"
              style={{ width: 180, height: 'auto', marginBottom: 16 }}
            />
            <h4 style={{ color: '#3CA8BC', fontWeight: 700, marginBottom: 2 }}>
              Portal TI
            </h4>
            <p style={{ color: '#8FA5AC', fontSize: '0.82rem', margin: 0 }}>
              Sistema de Gestao de TI
            </p>
          </div>

          {erro && (
            <div className="alert alert-danger py-2 px-3" style={{ fontSize: '0.85rem' }}>
              {erro}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-semibold" style={{ fontSize: '0.85rem' }}>
                Usuario
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="seu.usuario"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold" style={{ fontSize: '0.85rem' }}>
                Senha
              </label>
              <input
                type="password"
                className="form-control"
                placeholder="••••••••"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn w-100 fw-semibold"
              style={{
                background: 'linear-gradient(135deg, #2A8A9C 0%, #1E6370 100%)',
                color: '#fff',
                border: 'none',
                padding: '10px',
                boxShadow: '0 8px 20px rgba(42,138,156,0.35)',
              }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Entrando...
                </>
              ) : (
                'Entrar'
              )}
            </button>
          </form>

          <div className="text-center mt-3" style={{ color: '#5E7A82', fontSize: '0.72rem' }}>
            Centrao Materiais de Construcao
          </div>
        </div>
      </div>
    </div>
  );
}
